'use client';

import { VpButton } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { MainColumn } from '@/app/components/MainColumn';
import { useAuthenticatedContext } from '@/app/components/Provider';
import { Banner } from '~/components/commons/Banner/Banner';
import appConst from '~/const/appConst';

export const SignUpGuestBanner = () => {
  const t = useTranslations();

  const { redirectToLogin } = useAuthenticatedContext();

  return (
    <section
      data-testid="sign-up-guest-banner"
      data-cy="sign-up-guest-banner"
      className="sign-up-guest-banner"
    >
      <MainColumn>
        <Banner
          title={t('SIGN_UP_GUEST_BANNER.TITLE')}
          description={t('SIGN_UP_GUEST_BANNER.DESCRIPTION')}
        >
          <VpButton
            onClick={() => {
              redirectToLogin(appConst.staticRoutes.main_criterias);
            }}
          >
            {t('SIGN_UP_BANNER.CTA_LABEL')}
          </VpButton>
          <span>
            <p className="vp-subtitle-m">
              {t('SIGN_UP_GUEST_BANNER.ALREADY_SIGNED_IN')}
            </p>
            <VpButton
              variant="tertiary"
              onClick={() => {
                redirectToLogin(appConst.staticRoutes.main_criterias);
              }}
            >
              {t('HOMEPAGE.COMPLETE_PROFILE.BANNER.BUTTON')}
            </VpButton>
          </span>
        </Banner>
      </MainColumn>
    </section>
  );
};
